import RytmWebflow from 'rytm-webflow'
import { trace } from 'rytm-helpers'
import { WCAG } from "rytm-wcag"
import { windowUpdate, removeReCaptchaBadge } from './shared/common'
// controllers
import Controller from './controllers/Controller'
import ModspectsController from './controllers/ModspectsController'
import OdometerController from './controllers/OdometerController'
import OpeningController from './controllers/OpeningController'
// views
// import View from './views/View'

const routes = {
  'webflow': {
    controller: Controller,
    view: RytmWebflow.WebflowView
  },
  'list': {
    controller: Controller,
    view: RytmWebflow.WebflowListView
  },
  'modspects': {
    controller: ModspectsController,
    view: RytmWebflow.WebflowListView
  },
  'odometer': {
    controller: OdometerController,
    view: RytmWebflow.WebflowView
  },
  'opening': {
    controller: OpeningController,
    view: RytmWebflow.WebflowView
  },
}
const aswapProps = {
  animationTimeHide: 600,
  animationTimeShow: 800,
  preloadOnHover: false,
  cacheOn: true,
  refreshOnSameUrl: false,
  routes,
  trace,
}
const aswapEvents = {
  onViewSwapComplete: () => {
    WCAG.onViewChanged()
    windowUpdate()
    RytmWebflow.showUp.rebuild()
  },
  onViewShown: () => {
    RytmWebflow.scrollController.refresh();
  },
  onViewHide: () => {
    WCAG.dialogCloseAll()
    removeReCaptchaBadge()
    // RytmWebflow.showUp.hide()
    RytmWebflow.bootsrap5.hideFlyovers()
  },
  onViewHidden: () => {
    // destroy...
  },
  onRequestSameUrl: () => {
    // same url request
    RytmWebflow.bootsrap5.hideFlyovers();
  },
}

export const initASwap = () => {
  RytmWebflow.aswap.init(aswapProps, aswapEvents)
}